import { CommonModule } from '@angular/common';
import { LanguageDropdownRoutingModule } from './language-dropdown-routing.module';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LanguageDropdownRoutingModule,
  ]
})
export class LanguageDropdownModule { }
